import { TextOld } from '~/components/ui/text';
import { Title, TITLE_TYPE } from '~/components/ui/title';
import { COLORS } from '~/styles/colors';

import img1 from './assets/img1.png';
import img2 from './assets/img2.png';
import img3 from './assets/img3.png';
import img4 from './assets/img4.png';
import Card from './card/Card';
import { StyledCardsWrapper, StyledContainer, StyledSubTitle, StyledTitle } from './styled';

const LIST = [
  {
    id: 1,
    image: img1,
    title: 'Reduce printing expenses by switching to a paperless approach.',
    description:
      'Why not replace bulky paper menus with a few QR codes that your customers can conveniently scan? By generating a QR code for your restaurant menu, you can significantly cut down on printing expenses since QR codes require minimal ink and space.',
  },
  {
    id: 2,
    image: img2,
    title: 'Touchless menu access for your guests.',
    description:
      'One more advantage of using a QR Code for your restaurant menu is that it allows customers to scan and view the menu directly on their smartphones, ensuring a safer experience. With COVID-19 still posing a risk, this eliminates the need for handling physical menus that could carry germs or viruses. You can conveniently display the QR Code on table tents, windows, or even on the walls of your restaurant for easy access.',
  },
  {
    id: 3,
    image: img3,
    title: "QR Code designs perfectly aligned with your brand's identity.",
    description:
      'QR codes don’t need to stick to plain black and white. You can customize them to align with your restaurant or cafe’s color scheme. Add style by incorporating colors, frames, or even placing your logo at the center, ensuring they complement your overall design. Additionally, you can download them in four different image file formats, giving you complete flexibility for their usage.',
  },
  {
    id: 4,
    image: img4,
    title: 'Editable and Monitorable',
    description:
      'If you’re still not sold on the advantages, here’s the game-changer: the Dynamic Restaurant Menu QR Code allows you to update your menu whenever needed, even after it’s been printed. This eliminates the hassle and cost of reprinting. Additionally, every scan of your QR Code is trackable, providing data such as location, time of scan, and the device used. This means you can seamlessly integrate menu promotions into your broader marketing strategies.',
  },
];

export default function QrCodesInMenus() {
  return (
    <StyledContainer>
      <StyledTitle>
        <Title type={TITLE_TYPE.h2} color={COLORS.textMain} center>
          QR Codes in Menus
        </Title>
      </StyledTitle>
      <StyledSubTitle>
        <TextOld color={COLORS.grey400} fontWeight={400} textAlign="center">
          Digital menus mark a significant step forward in the world of gastronomy. Providing customers with a virtual
          menu — whether for a restaurant, bar, café, or delivery service — enables you to keep your product and price
          lists current without the need to repeatedly spend on printing materials.
        </TextOld>
      </StyledSubTitle>
      <StyledCardsWrapper>
        {LIST.map(({ id, image, title, description }) => {
          return <Card key={id} image={image} title={title} description={description} />;
        })}
      </StyledCardsWrapper>
    </StyledContainer>
  );
}
